/*
 * @Author: Lemon C
 * @Date: 2024-11-11 09:39:57
 * @LastEditTime: 2025-03-14 16:31:56
 */
/*
 * @Author: Lemon C
 * @Date: 2023-05-22 14:17:44
 * @LastEditTime: 2024-06-19 10:54:40
 */
import { createApp } from 'vue';
import App from './App.vue';
import ElementPlus from 'element-plus';
import { createPinia } from 'pinia';
import router from './router';
import * as ElementPlusIconsVue from '@element-plus/icons-vue';
import 'element-plus/theme-chalk/index.css';
import zhCn from 'element-plus/es/locale/lang/zh-cn'; //1 引入中文
import globalPlugin from './plugins/globalProperties-plugin';
import { PiniaPlugin } from './plugins/pinia-plugin';
import globalComponentPlugin from './plugins/globalComponent-plugin';

const app = createApp(App);
const pinia = createPinia();
pinia.use(PiniaPlugin);

app.use(pinia);
app.use(router);
app.use(ElementPlus, {
    locale: zhCn, //2 这里使用中文
});
app.use(globalPlugin);
app.use(globalComponentPlugin);

Object.keys(ElementPlusIconsVue).forEach((key) => {
    app.component(key, ElementPlusIconsVue[key]);
});

app.mount('#app');

if (process.env.NODE_ENV === 'production') {
    console.log = function () {};
}
